<template>
  <div class="campaign-main-section">
    <div class="ms-filter">
      <ms-form-filter
        :filters="filters"
        default-search="name"/>
    </div>
    <ms-grid
      :data="items"
      :columns="columns"
      :options="options"
      :pager="pager"
      :visible="visible"
      @notFoundItem="addNewCampaing">
      <div
        slot="name"
        slot-scope="{row}">
        <span class="title">{{ row.name }}</span>
        <br>
        <span class="description">{{ row.description }}</span>
      </div>
      <div
        slot="status"
        slot-scope="{row}">
        <el-tag
          v-if="row.status === 'published'"
          type="success"
          size="small">
          <strong>PUBLICADO</strong>
        </el-tag>
        <el-tag
          v-if="row.status === 'rejected'"
          type="danger"
          size="small">
          <strong>RECHAZADO</strong>
        </el-tag>
        <el-tag
          v-if="row.status === 'pending'"
          type="warning"
          size="small">
          <strong>PENDIENTE</strong>
        </el-tag>
        <el-tag
          v-if="row.status === 'pre-approved'"
          type="info"
          size="small">
          <strong>PRE-APROBADO</strong>
        </el-tag>
      </div>
    </ms-grid>
    <campaign-preview-mail
      v-if="showPreviewMail"
      :item-campaign="campaignSelected"
      :profile="profile"/>
    <campaign-create-view
      v-if="showCampaignEditPanel"
      :old="campaignSelected"
      @closeCampaign="closeCampaign"/>
  </div>
</template>

<script>
import MsFormFilter from '@/components/_shared/ms-form-filter'
import CampaignsGuards from '@/guards/campaigns.guards'
import CampaignPreviewMail from '@/modules/campaigns/campaign-preview-email-panel'
import CampaignCreateView from '@/views/app/campaigns/campaign-create-view'
import MsGrid from '@/modules/grid/ms-grid'
import FiltersCampaign from '@/utilis/filters-campaign'

export default {
  name: 'CampaignsListRecent',
  components: {
    MsFormFilter,
    CampaignPreviewMail,
    CampaignCreateView,
    MsGrid
  },
  data () {
    return {
      URL: process.env.API_URL_IMAGES,
      campaignSelected: null,
      filters: FiltersCampaign,
      options: {
        selectable: false,
        actions: [
          {
            label: 'Consultar',
            icon: 'icon-eye',
            onClick: (row) => {
              this.showCampaign(row)
            }
          },
          {
            label: 'Editar',
            icon: 'icon-edit',
            onClick: (row) => {
              this.editCampaign(row)
            }
          }
        ]
      },
      visible: false,
      showCampaignEditPanel: false
    }
  },
  computed: {
    items () {
      return this.$store.getters['campaigns/items']
    },
    showPreviewMail () {
      return this.$store.getters['app/showPreviewMail']
    },
    profile () {
      return this.$store.getters['profile/me']
    },
    columns () {
      let _columns = [
        {
          property: 'name',
          label: 'TÍTULO',
          align: 'center'
        },
        {
          property: 'created',
          label: 'CREADO POR',
          align: 'center'
        },
        {
          property: 'startDate',
          label: 'FECHA DE INICIO',
          align: 'center',
          type: 'date'
        },
        {
          property: 'endDate',
          label: 'FECHA DE CULMINACIÓN',
          align: 'center',
          type: 'date'
        }
      ]
      if (this.profile.role === 'superadmin') {
        _columns.push({
          property: 'dealerName',
          label: 'DISTRUIBUIDOR',
          align: 'center'
        },
        {
          property: 'status',
          label: 'ESTATUS',
          align: 'center'
        })
      } else {
        _columns.push({
          property: 'status',
          label: 'ESTATUS',
          align: 'center'
        })
      }
      return _columns
    },
    pager () {
      return this.$store.getters['campaigns/pagination']
    }
  },
  methods: {
    editCampaign (item) {
      this.showCampaignEditPanel = true
      this.campaignSelected = item
      this.$store.dispatch('app/toggleCampaignEditPanel')
    },
    showCampaign (item) {
      this.campaignSelected = item
      this.$store.dispatch('app/toogglePreviewMail')
    },
    addNewCampaing () {
      this.showCampaignEditPanel = true
      this.$emit('addCampaign')
      this.$store.dispatch('app/toggleCampaignPanel')
    },
    closeCampaign (value) {
      if (value) {
        this.showCampaignEditPanel = false
        this.$store.dispatch('app/toggleCampaignEditPanel')
      }
    }
  },
  beforeRouteUpdate: CampaignsGuards.recentCampaigns
}
</script>

<style scoped lang="scss">
  .campaign-main-section{
    padding: 20px;
    background-color: #ffffff;
    overflow: auto;
    min-height: 70vh;
    .ms-filter{
      margin: -20px -20px 0 -20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/campaigns/_shared/campaigns-list-recent.vue